import type { PageTemplateType } from '@repo/config';
import { stripLocalePrefix } from '@repo/web-chrome/lib/path';

export interface IPageContext {
  template: PageTemplateType;
  phrase: string | null;
}

function safeDecode(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

const SEGMENT_TEMPLATES: Array<{ prefix: string; template: PageTemplateType }> = [
  { prefix: '/challenge/', template: 'challenge' },
  { prefix: '/collection/', template: 'collection' },
  { prefix: '/cefr/', template: 'cefr' },
  { prefix: '/native/', template: 'native' },
  { prefix: '/compare/', template: 'compare' },
];

function matchSegmentTemplate(path: string): IPageContext | null {
  for (const { prefix, template } of SEGMENT_TEMPLATES) {
    if (path.startsWith(prefix)) {
      const slug = path.slice(prefix.length).split('/')[0] ?? '';
      return { template, phrase: slug ? safeDecode(slug) : null };
    }
  }
  return null;
}

export function pageContextFromPathname(pathname: string): IPageContext {
  const path = stripLocalePrefix(pathname);
  if (path === '' || path === '/') {
    return { template: 'home', phrase: null };
  }
  if (path === '/english-exams' || path.startsWith('/english-exams/')) {
    return { template: 'exam', phrase: null };
  }
  return matchSegmentTemplate(path) ?? { template: 'other', phrase: null };
}
